import dvaModelExtend from 'dva-model-extend';
import _ from 'lodash';

import { bindServices } from '@/services/api';
import { enhanceFormFieldDataWithTypes, toPaginate } from '@/utils/infrastructure';
import { createCrudModel } from '@/utils/core/dva';
import CoreQueries from '@/utils/input/queries';

import { ENTITY_NAME, FETCH_PARAMS, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);

const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute: FETCH_ROUTE,
  fetchParams: FETCH_PARAMS,
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: false },
  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const pageSize = yield select((state) => state.global.pageSize);
        const params = { ...CoreQueries[FETCH_PARAMS].paged, pageSize, ...payload };
        const res = yield call(api.getAll, {
          route: `${FETCH_ROUTE}/paged`,
          params,
          readPriority: true,
        });
        let items = enhanceFormFieldDataWithTypes(res?.items || res?.data || []);
        items = items.map((i) => ({ ...i, order: i.order ?? 0 }));
        const page = payload.page ?? 1;
        const limit = payload.limit ?? pageSize;
        const totalCount = res?.totalCount ?? res?.count ?? res?.total ?? items.length;
        yield put({ type: 'queryData', payload: { ...res, limit, page, totalCount, items } });
      } catch (e) {
        /*  */
      }
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: FETCH_ROUTE,
          id: payload.id,
          params: payload.detail
            ? CoreQueries[FETCH_PARAMS]?.itemDetail
            : {
                ...CoreQueries[FETCH_PARAMS]?.item,
                ...(payload?.params && { ...payload.params }),
              },
        });
        let item = enhanceFormFieldDataWithTypes(Array.isArray(res) ? res : [res])[0] || res;
        item = { ...item, order: item.order ?? 0 };
        yield put({ type: 'queryItem', payload: item });
      } catch (e) {
        /*  */
      }
    },

    *fetchDelete({ payload }, { call, put }) {
      try {
        const { id } = payload;
        yield put({ type: 'global/modalConfirm', payload: { state: false, id: null } });
        yield put({
          type: 'queryShowForm',
          payload: { state: false, item: null, detail: false, id: null },
        });
        yield call(api.remove, { route: FETCH_ROUTE, id });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'fetchList', payload: payload.params || {} });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },

    /** API has no bulk endpoint — delete one-by-one then refresh list. */
    *bulkDeleteExtraUserFields({ payload }, { call, put, select }) {
      try {
        const { ids } = payload;
        if (!ids || ids.length === 0) return;
        for (const id of ids) {
          yield call(api.remove, { route: FETCH_ROUTE, id });
        }
        const pageSize = yield select((state) => state.global.pageSize);
        const state = yield select((s) => s[MODEL_NAME]);
        const globalState = yield select((s) => s.global);
        const params = {
          ...CoreQueries[FETCH_PARAMS].paged,
          page: 1,
          limit: pageSize,
          ...(globalState.searchCriteria && { search: globalState.searchCriteria }),
          ...(state.orderBy && { orderBy: state.orderBy }),
          select: state.select,
        };
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'fetchList', payload: params });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },
  },
  reducers: {
    queryData(state, { payload }) {
      const items = payload.items ?? payload.data ?? state.list;
      return {
        ...state,
        list: items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
  },
});

export default dvaModelExtend(_model, { namespace: MODEL_NAME });
